import { apiClient } from './setupApi';

export const requestGetUsers = async ({
  page,
  size,
  orderBy,
  role,
  branch,
  status,
  orderType,
  search
}) => {
  const { data } = await apiClient.get('/user/', {
    params: {
      page: page + 1,
      size,
      order_by: orderBy,
      role: role && role.id !== 'all' ? role.id : undefined,
      branch: branch && branch.id !== 'all' ? branch.id : undefined,
      order_type: orderType,
      status: status.map((item) => item.value),
      search
    }
  });
  return data;
};

export const requestInviteUser = async (payload) => {
  const data = await apiClient.post('/user/', payload);
  return data;
};

export const requestDeactivateUser = async (id) => {
  await apiClient.patch(`/user/${id}/deactivate`);
};

export const requestActivateUser = async (id) => {
  await apiClient.patch(`/user/${id}/activate`);
};

export const requestGetUserById = async (id) => {
  const { data } = await apiClient.get(`/user/${id}`);
  return data;
};

export const requestUpdateUser = async (id, payload) => {
  const { data } = await apiClient.put(`/user/${id}`, payload);
  return data;
};

export const requestUpdateUserRole = async (id, payload) => {
  const { data } = await apiClient.patch(`/user/${id}/role`, payload);
  return data;
}

export const requestUploadPhotoUser = async (id, payload) => {
  const data = await apiClient.post(`/user/${id}/avatar`, payload);
  return data;
};

export const requestRepeatInviteUser = async (id) => {
  const data = await apiClient.patch(`/user/${id}/invite`);
  return data;
};

export const changeUserPassword = async (payload) => {
  const { data } = await apiClient.patch('/user/reset-password', payload);
  return data;
};

export const requestGetProfile = async () => {
  const { data } = await apiClient.get('/user/profile');
  return data;
}

export const requestUpdateProfile = async (payload) => {
  const { data } = await apiClient.put('/user/profile', payload);
  return data;
}

export const requestGetUserPermissions = async () => {
  const { data } = await apiClient.get('/user/permissions');
  return data;
}
